<h1 mat-dialog-title>{{title}}</h1>
<mat-dialog-content>
  <div #content></div>
</mat-dialog-content>
<mat-dialog-actions [align]="'end'">
  <button class="afm-button" (click)="dialog.close()">Dismiss</button>
</mat-dialog-actions>
